import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedCommonModule } from '../../shared/shared-common.module';

// Account Setup Wizard
import { AccountSetupWizardComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/account-setup-wizard.component';
import { WelcomeStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/welcome-step/welcome-step.component';
import { WelcomeOnboardingGalleryComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/welcome-onboarding-gallery/welcome-onboarding-gallery.component';
import { CompletionStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/completion-step/completion-step.component';

// Setup Steps
import { SiteTemplateStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/site-template-step/site-template-step.component';
import { HubVisionStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-vision-step/hub-vision-step.component';
import { HubIdeaStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-idea-step/hub-idea-step.component';
import { HubIdentityStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-identity-step/hub-identity-step.component';
import { HubBrandingStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-branding-step/hub-branding-step.component';
import { HubInstructorStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-instructor-step/hub-instructor-step.component';
import { HubLegalBusinessDetailsStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-legal-business-details-step/hub-legal-business-details-step.component';
import { HubHomeBannerStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-home-banner-step/hub-home-banner-step.component';
import { PortalIdentityStepComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/portal-identity-step/portal-identity-step.component';

// Branding Components
import { ColorPaletteViewComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-branding-step/color-palette-view/color-palette-view.component';
import { LogoSelectorComponent } from '../../shared/layout/owner-dashboard/account-setup-wizard/steps/hub-branding-step/logo-selector/logo-selector.component';

// Funnel Wizard
import { FunnelCreateWizardComponent } from '../../components/user-dashboard/funnel/create/funnel-create-wizard/funnel-create-wizard.component';
import { FunnelsLayoutComponent } from '../../shared/wizard/funnels-layout/funnels-layout.component';
import { FunnelItemComponent } from '../../shared/wizard/funnels-layout/funnel-item/funnel-item.component';
import { FunnelItemInfoPopupComponent } from '../../shared/wizard/funnels-layout/funnel-item/funnel-item-info-popup/funnel-item-info-popup.component';
import { FunnelItemPageComponent } from '../../shared/wizard/funnels-layout/funnel-item/funnel-item-info-popup/funnel-item-page/funnel-item-page.component';

// Template Components
import { TemplatesLayoutComponent } from '../../shared/wizard/templates-layout/templates-layout.component';
import { TemplateItemComponent } from '../../shared/wizard/templates-layout/template-item/template-item.component';
import { TemplateItemInfoPopupComponent } from '../../shared/wizard/templates-layout/template-item/template-item-info-popup/template-item-info-popup.component';
import { TemplateItemPageComponent } from '../../shared/wizard/templates-layout/template-item/template-item-info-popup/template-item-page/template-item-page.component';

// Wizard UI Components
import { WizardSummaryComponent } from '../../shared/wizard/wizard-summary/wizard-summary.component';
import { SummaryItemComponent } from '../../shared/wizard/wizard-summary/summary-item/summary-item.component';
import { WizardStepItemComponent } from '../../shared/wizard/partials/wizard-step-item/wizard-step-item.component';
import { SelectPortalComponent } from '../../shared/wizard/select-portal/select-portal.component';
import { StepsUiViewComponent } from '../../shared/wizard/steps-ui-view/steps-ui-view.component';
import { InformativeSectionComponent } from '../../shared/wizard/informative-section/informative-section.component';
import { ItemGalleryComponent } from '../../shared/wizard/item-gallery/item-gallery.component';
import { ImagePreviewPopoverComponent } from '../../shared/wizard/item-gallery/image-preview-popover/image-preview-popover.component';
import { MediaLibraryModule } from '../media-library/media-library.module';
import { AiModule } from '../ai/ai.module';

const WIZARD_COMPONENTS = [
  // Account Setup
  AccountSetupWizardComponent,
  WelcomeStepComponent,
  WelcomeOnboardingGalleryComponent,
  CompletionStepComponent,

  // Setup Steps
  SiteTemplateStepComponent,
  HubVisionStepComponent,
  HubIdeaStepComponent,
  HubIdentityStepComponent,
  HubBrandingStepComponent,
  HubInstructorStepComponent,
  HubLegalBusinessDetailsStepComponent,
  HubHomeBannerStepComponent,
  PortalIdentityStepComponent,

  // Branding
  ColorPaletteViewComponent,
  LogoSelectorComponent,

  // Funnel Wizard
  FunnelCreateWizardComponent,
  FunnelsLayoutComponent,
  FunnelItemComponent,
  FunnelItemInfoPopupComponent,
  FunnelItemPageComponent,

  // Templates
  TemplatesLayoutComponent,
  TemplateItemComponent,
  TemplateItemInfoPopupComponent,
  TemplateItemPageComponent,

  // UI Components
  WizardSummaryComponent,
  SummaryItemComponent,
  WizardStepItemComponent,
  SelectPortalComponent,
  StepsUiViewComponent,
  InformativeSectionComponent,
  ItemGalleryComponent,
  ImagePreviewPopoverComponent,
];

/**
 * WizardModule
 *
 * Purpose: Contains all wizard and onboarding components:
 * - Account setup wizard and steps
 * - Branding and identity configuration
 * - Funnel creation wizard
 * - Template selection
 * - Wizard UI components and navigation
 */
@NgModule({
  declarations: WIZARD_COMPONENTS,
  imports: [
    SharedCommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    MediaLibraryModule,
    AiModule,
  ],
  exports: WIZARD_COMPONENTS,
  schemas: [],
})
export class WizardModule {}
